<template>
  <el-dialog :visible.sync="isVisible" title="账号自动禁用" width="666px" :close-on-click-modal="false" @closed="onModalClose">
    <ElForm label-width="120px" class="ghost-button-styles">
      <ElFormItem label="触发时间配置">
        <div style="display: flex">
          <span>&ensp;每月&ensp;</span>
          <el-select v-model="landData.days" multiple placeholder="选择日期" collapse-tags filterable clearable style="width: 160px">
            <el-option v-for="item in 31" :key="item" :value="item" :label="`${item}号`" style="width: 160px"></el-option>
          </el-select>

          <span>&ensp;时间&ensp;</span>

          <el-select v-model="landData.hours" multiple placeholder="选择时间" collapse-tags filterable clearable style="flex: 1">
            <el-option
              v-for="item in 24"
              :key="item"
              :value="item"
              :label="`${item < 10 ? `0${item}` : item}:00`"
              style="width: 160px"
            ></el-option>
          </el-select>
        </div>
      </ElFormItem>
      <ElFormItem label="关停规则">
        <span style="color: #ff6400">本月无消耗且近15日无消耗，余额为0，非近15日新增账号</span>
      </ElFormItem>

      <ElFormItem label="提醒方式">
        <el-radio-group v-model="landData.alertType">
          <el-radio-button ghost :label="1"> 仅邮件 </el-radio-button>
          <el-radio-button ghost :label="2"> 仅钉钉 </el-radio-button>
          <el-radio-button ghost :label="3"> 邮件和钉钉 </el-radio-button>
        </el-radio-group>
      </ElFormItem>
      <ElFormItem label="提醒人员">
        <el-select
          v-model="landData.alertOpIds"
          multiple
          placeholder="选择提醒人员"
          style="width: 100%"
          filterable
          clearable
          :popper-append-to-body="false"
        >
          <el-option v-for="item in opData" :key="item.id" :value="item.id" :label="item.name" style="width: 200px"></el-option>
        </el-select>
      </ElFormItem>
    </ElForm>

    <span slot="footer" class="dialog-footer">
      <slot></slot>
    </span>
  </el-dialog>
</template>
<script>
import { isArray } from '@/common/js/utils'

export default {
  name: 'AccountDisableModal',
  props: {
    value: {
      type: Boolean
    },

    opData: {
      type: Array
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    onModalClose() {
      this.landData = this.initForm()
    },
    setForm(form) {
      this.landData = form
    },
    // 提交验证
    getForm() {
      const { days, hours, alertType, alertOpIds } = this.landData
      if (!isArray(days) || days.length === 0) {
        this.$Message.warning('请选择日期！')
      }
      if (!isArray(hours) || hours.length === 0) {
        this.$Message.warning('请选择时间！')
      }
      if (!isArray(alertOpIds) || alertOpIds.length === 0) {
        this.$Message.warning('请选择提醒人！')
      }
      const params = {
        email_type2: alertType,
        opIds_monitor2: alertOpIds.join(','),
        days: days.join(','),
        hours: hours.join(',')
      }

      return params
    },
    initForm() {
      return {
        days: [],
        hours: [],
        alertType: 1,
        alertOpIds: []
      }
    }
  },
  data() {
    return {
      landData: this.initForm()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-account-disable {
  position: relative;
}
</style>
